export const ELEMENTARY = ['3rd', '4th', '5th'];
export const MIDDLE_SCHOOL = ['6th', '7th', '8th'];
export const HIHG_SCHOOL = ['9th', '10th', '11th', '12th'];
export const ALL_GRADES = ['3rd', '4th', '5th', '6th', '7th', '8th', '9th', '10th', '11th', '12th'];
export const ALL_GRADES_ADD = [
    { value: 3, label: '3rd' },
    { value: 4, label: '4th' },
    { value: 5, label: '5th' },
    { value: 6, label: '6th' },
    { value: 7, label: '7th' },
    { value: 8, label: '8th' },
    { value: 9, label: '9th' },
    { value: 10, label: '10th' },
    { value: 11, label: '11th' },
    { value: 12, label: '12th' }
];
